exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".main-canvas{position:absolute;top:0;left:0;z-index:5}.data-canvas{position:absolute;display:none}.tileset-canvas{position:absolute;display:none}", ""]);

